import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Shield, Award, FileCheck, AlertTriangle, Download } from 'lucide-react';

export const Compliance = () => {
  const { t } = useLanguage();

  const complianceFeatures = [
    {
      icon: Shield,
      title: t.compliance.titles[0],
      description: t.compliance.points[0]
    },
    {
      icon: Award,
      title: t.compliance.titles[1],
      description: t.compliance.points[1]
    },
    {
      icon: FileCheck,
      title: t.compliance.titles[2],
      description: t.compliance.points[2]
    },
    {
      icon: Download,
      title: t.compliance.titles[3],
      description: t.compliance.points[3]
    }
  ];

  return (
    <section id="compliance" className="py-20 bg-gradient-to-br from-blue-50 to-teal-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t.compliance.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.compliance.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mt-6 rounded-full" />
        </div>

        {/* Compliance Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {complianceFeatures.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <IconComponent className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Standards Section */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900">
                {t.compliance.certification.title}
              </h3>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-900">{t.compliance.certification.topics[0]}</p>
                    <p className="text-sm text-gray-600">
                      {t.compliance.certification.descriptions[0]}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-secondary rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-900">
                      {t.compliance.certification.topics[1]}
                    </p>
                    <p className="text-sm text-gray-600">
                      {t.compliance.certification.descriptions[1]}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-900">
                      {t.compliance.certification.topics[2]}
                    </p>
                    <p className="text-sm text-gray-600">
                      {t.compliance.certification.descriptions[2]}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-secondary rounded-full mt-2 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-900">
                      {t.compliance.certification.topics[3]}
                    </p>
                    <p className="text-sm text-gray-600">
                      {t.compliance.certification.descriptions[3]}
                    </p>
                  </div>
                </div>
              </div>

              <Button
                onClick={() => console.log('Request certificates')}
                className="bg-primary hover:bg-primary/90 text-white"
              >
                <FileCheck className="w-4 h-4 mr-2" />
                {t.compliance.ctaCertificates}
              </Button>
            </div>

            {/* Visual Element */}
            <div className="relative">
              <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl p-8 text-center">
                <div className="space-y-6">
                  <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                    <Shield className="w-10 h-10 text-primary" />
                  </div>
                  <div className="space-y-2">
                    <h4 className="text-lg font-bold text-gray-900">
                      {t.compliance.qualityAssured.title}
                    </h4>
                    <p className="text-gray-600">
                      {t.compliance.qualityAssured.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        {/* <div className="mt-12 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
          <div className="flex gap-3">
            <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="font-semibold text-yellow-800 mb-2">
                {t.language === 'en' ? 'Important Notice' : 'ประกาศสำคัญ'}
              </h4>
              <p className="text-yellow-700 text-sm leading-relaxed">
                {t.compliance.disclaimer}
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};